import React from 'react';
import PropTypes from 'prop-types';
import {
  PrimaryButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@bb-ui/react-library/dist/components';

export const NotificationModal = ( props ) => {
  const {
    modalVisible,
    toggleModal,
    modalProps = {
      title : '',
      body : '',
      confirm : '',
      id : 'modal'
    }
  } = props;

  const renderModal = () => {
    if ( !modalProps ) {
      return null;
    }

    const {
      title,
      body,
      confirm,
      id
    } = modalProps;

    return (
      <Dialog
        open={modalVisible}
        onClose={() => toggleModal()}
        onRendered={() => document.getElementById(`${id}-dialog-title`).focus()}
        aria-labelledby={`${id}-dialog-title`}
      >
        <DialogTitle
          onClose={() => toggleModal()}
          id={`${id}-dialog-title`}
        >
          { title }
        </DialogTitle>
        <DialogContent>
          {body}
        </DialogContent>
        <DialogActions>
          <PrimaryButton
            onClick={() => toggleModal()}
          >
            { confirm }
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  };

  return renderModal();
};

NotificationModal.propTypes = {
  modalVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  modalProps: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
    confirm: PropTypes.string,
    id: PropTypes.string
  })
};